module.exports = __webpack_public_path__ + "static/img/banner3.188fd74.png";